// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { WelcomeAdminPanelAreaRoutes } from '@backoffice-frontend/welcome-api'
import { lazy } from 'react'
import { WelcomeAdminPanelAreaId } from './WelcomeAdminPanelAreaId'

import { WelcomeAdminPanelAreaNavigation } from './WelcomeAdminPanelAreaNavigation'

const LazyWelcomeAdminPanelComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./WelcomeAdminPanelArea')),
)

const WelcomeAdminPanelComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyWelcomeAdminPanelComponent />
  </SuspenseLoadingWrapper>
)

export const WelcomeAdminPanelArea = {
  id: WelcomeAdminPanelAreaId,
  NavigationComponent: WelcomeAdminPanelAreaNavigation,
  route: {
    path: WelcomeAdminPanelAreaRoutes.route,
    component: WelcomeAdminPanelComponent,
  },
}
